import React, {useState, useEffect} from 'react';
import {Helmet} from 'react-helmet';
import {Link, useSearchParams} from 'react-router-dom';
import {
    Box,
    Container,
    Avatar,
    Card,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    TableFooter,
    TablePagination,
    TextField,
    Divider,
    Alert
} from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import UserListSkelet from '../../skeletons/UserListSkelet';
import {useDelete, useGet} from '../../API/request';
import {useConfirm} from "../../components/Confirm/index";
import {BallTriangle} from "react-loader-spinner";
import '../../styles/All.css'
import { PriceChildrenSection } from './PriceChildrenSection';
import { useAlert } from '../../components/Alert';
import PriceOpenModal from './PriceOpenModal';
import useSavePagePagination from '../../hooks/useSavePagePagination';

const PriceSectionList = () => {

    const confirm = useConfirm();
    const getU = useGet();
    const deleteU = useDelete();

    const [isLoaded, setIsLoaded] = useState(true);
    const [isDataLoading, setIsDataLoading] = useState(true);
    const [sections, setSections] = useState([]);
    const {page, limit, setPage, setLimit}  = useSavePagePagination('prices-paginatation')
    const [count, setCount] = useState(0);

    const [alert, setAlert] = useState({
        txt: '',
        isVisible: false,
        type: 'error'
    });

    const showAlert = (type, text) => {
        setAlert({
            txt: text,
            type,
            isVisible: true
        });

        setTimeout(() => {
            setAlert({
                txt: text,
                type,
                isVisible: false
            });
        }, 1400);
    };

    const loadSection = () => {
        setIsDataLoading(true);
        setIsLoaded(true)

        let endpoint = `price/section?page=${page + 1}&limit=${limit}`;

        getU(endpoint)
            .then((resp) => {
                if (resp.status === 'success') {
                    setSections(resp.data.section);
                    setCount(resp.data.totalCount || 0);
                }
                setIsDataLoading(false);
            })
            .catch((err) => {
                console.log(err.response)
                setSections([]);
                setCount(0);
                setIsDataLoading(false);
            })
            .finally(() => {
                setIsLoaded(false)
            });
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeLimit = (event) => {
        setLimit(event.target.value);
        setPage(0);
    };

    useEffect(() => {
        loadSection();
    }, [page, limit]);

    if (isLoaded) {
        return (
            <div className="loader">
                <BallTriangle
                    height="100"
                    width="100"
                    color='grey'
                    ariaLabel='loading'
                />
            </div>
        );
    }

    return (
        <>
            <Helmet>
                <title>Прайс</title>
            </Helmet>
            <Box className="headerWrapper">
                <Box className="headerTitle">
                    Прайс
                </Box>
            </Box>
            <Box sx={{backgroundColor: 'background.default', minHeight: '100%', py: 3}}>
                <Container maxWidth={false}>
                    {
                        isDataLoading ?
                            <UserListSkelet/>
                            :
                            <>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Box>
                                        <PriceOpenModal>
                                            {({ openModal }) => (
                                                <Button
                                                color="primary"
                                                variant="contained"
                                                onClick={openModal}
                                                >
                                                    Поиск прайса
                                                </Button>
                                            )}
                                        </PriceOpenModal>
                                    </Box>
                                    <Box>
                                        <Link to="/app/price-sections/add/">
                                        <Button color="primary" variant="contained">
                                            Добавить новый раздел
                                        </Button>
                                        </Link>
                                    </Box>
                                </Box>
                                <Box sx={{pt: 3}}>
                                    <Card>
                                        <PerfectScrollbar>
                                            <Box sx={{minWidth: 1000}}>
                                                <Divider/>
                                                <PriceChildrenSection
                                                    allSections={sections}
                                                    cnt={count}
                                                    loadSection={loadSection}
                                                    showAlert={showAlert}
                                                    limit={limit}
                                                    page={page}
                                                    handleChangeLimit={handleChangeLimit}
                                                    handleChangePage={handleChangePage}
                                                />
                                                <Alert severity={alert.type}
                                                        style={{display: alert.isVisible ? 'flex' : 'none'}}>
                                                    {alert.txt}
                                                </Alert>
                                            </Box>
                                        </PerfectScrollbar>

                                    </Card>
                                </Box>
                            </>
                    }
                </Container>
            </Box>
        </>
    );
};

export default PriceSectionList;
